import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { ITemplateCurrenciesList } from '../model/templateCurrenciesList';

export const templateCurrenciesListKey = () => ['templateCurrenciesListSelect'];
export const templateCurrenciesListFn = () =>
  apiClient.get(`${APP_API_URL_V2}fsd/action-item/cost-savings-settings/template/currencies`);

const templateCurrenciesListSelect = ({ data }: AxiosResponse<{ data: ITemplateCurrenciesList[] }>) => data.data;

export const useTemplateCurrenciesListQuery = () => {
  return useQuery({
    queryKey: templateCurrenciesListKey(),
    queryFn: templateCurrenciesListFn,
    select: templateCurrenciesListSelect,
  });
};
